export default Object.freeze({
  Pending: 0,
  Finished: 1,
  Rejected: 2,
  Overdue: 3,
  Skipped: 4,
  Error: 5,
  Execution: 6,
});
